/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { payloadReducer } from '@zcode/reducers'
import type { Geo } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { handleAction } from 'redux-actions'
import { GET_GEOS_SUCCESS } from './constants'
import type { ActionTypes } from './types'

export const geoReducer = handleAction<MaybeEmpty<Geo>, ActionTypes, typeof GET_GEOS_SUCCESS>(
  GET_GEOS_SUCCESS,
  payloadReducer,
  {}
)
